module.exports = __webpack_public_path__ + "img/economicsBlue.634878e1.png";